import * as Yup from 'yup';
import { DictProcessingType } from '@models';

export function useValidationSchema() {
  return Yup.object<DictProcessingType>().shape({
    name: Yup.string().nullable().required(),
  });
}
